import { Button, EmptyState } from '@uatp/ui';
import { Compass } from 'lucide-react';
import { Link } from 'react-router';
import { Page } from '../components/layout';
import { usePageMeta } from '../shell/store';

export function NotFoundPage() {
  usePageMeta([{ label: 'Not found' }]);
  return (
    <Page>
      <EmptyState
        icon={<Compass />}
        title="Page not found"
        description="The link may be outdated, or the item was moved or deleted."
        action={
          <Button asChild>
            <Link to="/">Back to dashboard</Link>
          </Button>
        }
        bordered
        headingLevel={2}
      />
    </Page>
  );
}
